import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PermissionsService } from '../../services/permissions/permissions.service';

@Injectable({
	providedIn: 'root',
})
export class PermissionsGuard implements CanActivate, CanActivateChild {
	constructor(
		private permissionsService: PermissionsService,
		private router: Router,
	) {}

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | boolean | UrlTree {
		return this.check(route);
	}

	canActivateChild(childRoute: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | boolean | UrlTree {
		return this.check(childRoute);
	}

	// The required view comes from the route's `data.viewId` (a MENU id, or a list of ids
	// where any one of them grants access). Routes without it require no permission.
	private check(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | boolean | UrlTree {
		const viewId = route.data?.['viewId'];
		if (viewId == null) return true;

		const viewIds: number[] = Array.isArray(viewId) ? viewId : [viewId];

		if (this.permissionsService.arePermissionsLoaded()) {
			return this.checkPermission(viewIds);
		}

		return this.permissionsService.loadUserPermissions().pipe(
			map((loaded: boolean) => {
				if (!loaded) {
					console.error('Error al cargar permisos del usuario');
					return this.router.createUrlTree(['/access-denied']);
				}
				return this.checkPermission(viewIds);
			}),
		);
	}

	private checkPermission(viewIds: number[]): boolean | UrlTree {
		if (viewIds.some((id) => this.permissionsService.hasPermissionForView(id))) return true;
		console.warn(`Acceso denegado para la vista ${viewIds.join(', ')}.`);
		return this.router.createUrlTree(['/access-denied']);
	}
}
